import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class CustomIconComponent extends Vue {
    @Prop({
        validator: (value) => {
            // eslint-disable-next-line no-prototype-builtins
            if ((<any>window).appConfig.staticPathsWithHash.hasOwnProperty(value)) {
                return true;
            } else {
                console.error(`window.appConfig.staticPathsWithHash has no prop "${value}". You should add "src" as property of window.appConfig.staticPathsWithHash. Look "_Scripts.cshtml".`);

                return false;
            }
        }
    })
    src: string;

    @Prop({ type: [String, Object] })
    iconName: string | object;

    get icon() {
        if (typeof this.iconName === 'object' && this.iconName !== null) {
            for (const className in this.iconName) {
                if (this.iconName[className]) {
                    return className;
                }
            }
        }
        
        return this.iconName;
    }

    get componentClassAttribute() {
        const result = {
            'icon': true
        };

        result[`icon-${this.icon}`] = true;

        return result;
    }

    get xlinkHref() {
        return this.icon
            ? `${(<any>window).appConfig.staticPathsWithHash[this.src]}#${this.icon}`
            : `${(<any>window).appConfig.staticPathsWithHash[this.src]}`;
    }
}
